import { render, staticRenderFns } from "./inspectable-action-documents.vue?vue&type=template&id=c568acb2&scoped=true"
import script from "./inspectable-action-documents.vue?vue&type=script&lang=js"
export * from "./inspectable-action-documents.vue?vue&type=script&lang=js"
import style0 from "./inspectable-action-documents.vue?vue&type=style&index=0&id=c568acb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c568acb2",
  null
  
)

export default component.exports